module.exports = __webpack_public_path__ + "static/media/environment_living-min.e98ec378.jpg";